import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { OidcToken } from './OidcToken';
export class OidcIdToken extends OidcToken {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "preferredUsername", this.getClaim('urn:oriflame:activeDirectory:preferred_username'));

    _defineProperty(this, "name", this.getClaim('name'));
  }

}
//# sourceMappingURL=OidcIdToken.js.map